import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { format } from "date-fns";
import { AdminAppStudentPaymentsResponse } from "../../models/dtos";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";

interface PaymentsTableProps {
  payments: AdminAppStudentPaymentsResponse[];
  onEditPayment: (payment: AdminAppStudentPaymentsResponse) => void;
  onDeletePayment: (paymentId: number) => void;
  onUpdatePayment: (payment: AdminAppStudentPaymentsResponse) => void;
}

const PaymentsTable = ({ payments, onEditPayment: _onEditPayment, onDeletePayment, onUpdatePayment }: PaymentsTableProps) => {

  const setPaymentStatus = (rowData: AdminAppStudentPaymentsResponse) => {
    switch (rowData.paymentStatusId) {
      case 1:
        return (
          <Tag
            style={{ background: "linear-gradient(-225deg, #6c757d 0%, #6c757d 100%)" }}
            value={`${rowData.paymentStatus}`}
            rounded
          ></Tag>
        );
      case 3:
        return <Tag severity="success" value={`${rowData.paymentStatus}`} rounded></Tag>;
      case 2:
        return <Tag severity="warning" value={`${rowData.paymentStatus}`} rounded></Tag>;
      default:
        return <Tag severity="danger" value={`${rowData.paymentStatus}`} rounded></Tag>;
    }
  };

  const onRowEditComplete = (e: any) => {
    const { newData } = e;
    const updatedData = {
        ...newData,
        amount: newData.amount ? Number(newData.amount) : 0
    };
    onUpdatePayment(updatedData);
  };

  const dateEditor = (options: any) => {
    return (
      <Calendar
        value={new Date(options.value)}
        onChange={(e) => options.editorCallback(e.value)}
        dateFormat="dd.mm.yy"
      />
    );
  };

  const amountEditor = (options: any) => {
    return (
      <InputNumber
        value={options.value}
        onValueChange={(e) => options.editorCallback(e.value)}
        mode="decimal"
        minFractionDigits={2}
        maxFractionDigits={2}
      />
    );
  };

  const confirmDelete = (event: React.MouseEvent, paymentId: number) => {
    confirmPopup({
      target: event.currentTarget as HTMLElement,
      message: 'Сигурни ли сте, че искате да изтриете това плащане?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => onDeletePayment(paymentId),
      acceptLabel: 'Да',
      rejectLabel: 'Не'
    });
  };

  return (
    <>
      <ConfirmPopup />
      <DataTable
        value={payments}
        paginator
        rows={10}
        header="Всички плащания"
        emptyMessage="Няма открити плащания"
        editMode="row"
        onRowEditComplete={onRowEditComplete}
        dataKey="paymentId"
      >
        <Column field="paymentType" header="Тип плащане" body={(rowData) => rowData.paymentType} />
        <Column
          field="startedOn"
          header="Дата на плащане"
          body={(rowData) => format(new Date(rowData.startedOn), "dd.MM.yyyy")}
          editor={(options) => dateEditor(options)}
        />
        <Column
          field="amount"
          header="Сума"
          body={(rowData) => rowData.amount?.toFixed(2)}
          editor={(options) => amountEditor(options)}
        />
        <Column field="bank" header="Банка" body={(rowData) => rowData.bank ?? ""} />
        <Column field="bankStatusDescription" header="Статус" body={(rowData) => setPaymentStatus(rowData)} />
        <Column
          field="posTerminalId"
          header="ПОС терминал"
          body={(rowData) => (rowData.posTerminalId ? "Да" : "Не")}
        />
        <Column
          rowEditor
          headerStyle={{ width: '10%', minWidth: '8rem' }}
          bodyStyle={{ textAlign: 'center' }}
        />
        <Column body={(rowData) => (
          <Button
            icon="pi pi-trash"
            className="p-button-rounded p-button-text"
            onClick={(e) => confirmDelete(e, rowData.paymentId)}
          />
        )} />
      </DataTable>
    </>
  );
};

export default PaymentsTable; 
